
import { useState } from "react";
import ContentEditor from "./ContentEditor";
import ContentPreview from "./ContentPreview";
import ContentTabHeader from "./ContentTabHeader";

interface TermsTabProps {
  termsValue: string;
  setTermsValue: (value: string) => void;
  getLastUpdatedText: (key: string) => string;
  handleSaveTerms: () => void;
  saving: boolean;
}

const TermsTab = ({
  termsValue,
  setTermsValue,
  getLastUpdatedText,
  handleSaveTerms,
  saving
}: TermsTabProps) => {
  const [previewMode, setPreviewMode] = useState(false);
  
  return (
    <div className="space-y-4">
      <ContentTabHeader 
        lastUpdated={getLastUpdatedText("terms_and_conditions")}
        previewMode={previewMode}
        togglePreview={() => setPreviewMode(!previewMode)}
        handleSave={handleSaveTerms}
        saving={saving}
      />
      
      {previewMode ? (
        <ContentPreview content={termsValue} />
      ) : (
        <ContentEditor 
          value={termsValue}
          onChange={setTermsValue}
        />
      )}
    </div>
  );
};

export default TermsTab;
